import {createReducer} from "./index";
import * as R from 'ramda';
import {ADD_PHOTOS} from "../actions/photos";

const filesInitial = {
  data: {},
  indexes: {
    bid: {},
    project: {},
  }
};

function addFiles(state, files) {
  let newState = state;
  files.forEach(file => {
    if (!file) return;
    newState = R.over(R.lensPath(['data', file.id]), () => file)(newState);
    newState = R.over(R.lensPath(['indexes', file.associationtype, file.associatedid]), value => {
      if (!value) {
        return {[file.id]: 1};
      } else {
        return {...value, [file.id]: 1};
      }
    })(newState);
  });
  return newState;
}

const photosReducer = createReducer(filesInitial,
  {
    // 'ACTION_NAME': function (state, action) -> new_state
    [ADD_PHOTOS]: (state, action) => addFiles(state, action.payload),
  });

export default photosReducer;



// WEBPACK FOOTER //
// ./src/reducers/photos.js